<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.735"
    height="22.156"
    viewBox="0 0 24.735 22.156"
  >
    <path
      class="svg-primary"
      d="M13.647,24.488H3.773c-.722,0,0,.795,0,0h9.9c0-.795,7.851-8.4,8.573-8.4l.674-5.588c.722,0-.674.266-.674,1.06v4.528a.673.673,0,0,0,.674.674.689.689,0,0,0,.674-.674V11.556A2.763,2.763,0,0,0,20.92,8.738H16.248v-1.4A1.527,1.527,0,0,0,14.755,5.8H9.673A1.527,1.527,0,0,0,8.18,7.341v1.4H3.773A2.763,2.763,0,0,0,1.1,11.556V23.043a2.763,2.763,0,0,0,2.673,2.818h9.9a.673.673,0,0,0,.674-.674A.7.7,0,0,0,13.647,24.488ZM9.553,7.365c0-.1.072-.193.12-.193h5.081c.048,0,.12.072.12.193V8.738H9.553Z"
      transform="translate(-1.1 -5.8)"
    />
    <circle
      class="white-fill"
      cx="6.5"
      cy="6.5"
      r="6.5"
      transform="translate(11.735 9.156)"
    />
    <path
      class="svg-primary"
      d="M67.505,61.773l-1.589-1.589a4.38,4.38,0,0,0,.795-2.529,4.455,4.455,0,1,0-4.455,4.455,4.531,4.531,0,0,0,2.794-.987l1.541,1.541a.64.64,0,0,0,.915,0A.64.64,0,0,0,67.505,61.773Zm-5.25-.915a3.179,3.179,0,1,1,3.179-3.179A3.191,3.191,0,0,1,62.255,60.858Z"
      transform="translate(-44.145 -41.785)"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
.white-fill {
  fill: #fff;
}
</style>
